(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/printable-coupon/assets/javascripts/outcomes.js') >= 0) return;  svs.modules.push('/components/pool-betting/printable-coupon/assets/javascripts/outcomes.js');
"use strict";


const AnimatedCircle = svs.components.marketplace.animatedCircle.AnimatedCircle;
const OUTCOME_SCORE_ALTERNATIVES = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10+'];
const Outcomes = _ref => {
  let className = _ref.className,
    signs = _ref.signs;
  return React.createElement("div", {
    className: className
  }, OUTCOME_SCORE_ALTERNATIVES.map((outcome, index) => React.createElement("div", {
    className: "event__outcome",
    key: outcome
  }, React.createElement("div", {
    className: "event__outcome__number"
  }, outcome, (signs === null || signs === void 0 ? void 0 : signs[index]) && React.createElement(AnimatedCircle, {
    animate: false,
    isVisible: true
  })))));
};
setGlobal('svs.components.poolBetting.printableCoupon.Outcomes', Outcomes);

 })(window);